<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <h2 *ngIf="currentItem?.displayName">{{ currentItem?.displayName }} [{{ currentItem?.code }}]</h2>
      </div>
      <div class="div-btns-top">
        <action-bar
          [showSave]="true"
          [showAddToFavorites]="!favoriteId && currentItem && currentItem.resourceId"
          [showRemoveFromFavorites]="favoriteId"
          [showDuplicate]="!!currentItem?.canDuplicate"
          [showDelete]="(state?.perimeterId == currentItem?.ownerId || !currentItem?.resourceId || currentItem?.canUpdate) && currentItem && currentItem.resourceId"
          (onSave)="clickSave(currentItem)"
          (onAddToFavorites)="addToFavorite(currentItem.resourceId!)"
          (onRemoveFromFavorites)="removeFromFavorite()"
          (onDuplicate)="onDplicateAch(currentItem.resourceId!)"
          (onDelete)="onDeleteDialog(currentItem.resourceId!)"></action-bar>
      </div>
    </div>
    <div
      [class]="{
        'disabled-form': !(state?.perimeterId == currentItem?.ownerId || !currentItem?.resourceId || currentItem?.canUpdate)
      }">
      <div class="identification">
        <h3 class="title-margin-top">{{ 'common_section_identification' | translate }}</h3>
        <mat-card>
          <mat-grid-list cols="10" rowHeight="60px" gutterSize="20px">
            <mat-grid-tile colspan="2">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_code' | translate }}</mat-label>
                <input matInput formControlName="code" minlength="2" maxlength="30" required />
                <mat-error *ngIf="formCrls.code.invalid">{{ 'ref_error_code_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <mat-form-field>
                <mat-label>{{ 'common_field_label' | translate }}</mat-label>
                <input matInput formControlName="displayName" maxlength="100" required />
                <mat-hint align="end">{{ form.value.displayName?.length || 0 }} / 100</mat-hint>
                <mat-error *ngIf="formCrls.displayName.invalid">{{ 'ref_error_label_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_owner' | translate }}</mat-label>
                <input matInput disabled [value]="currentItem?.owner | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_creator' | translate }}</mat-label>
                <input matInput disabled [value]="currentItem?.creator | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>
      <div class="justificatif-section">
        <mat-card>
          <div class="row">
            <div class="col-3" *ngIf="currentItem?.canUpdate || !currentItem?.resourceId">
              <div class="justificatif" [matTooltip]="!currentItem?.resourceId ? ('ref_save_before_add_proof' | translate) : ''">
                <input id="singleFile" type="file" class="inputfile" accept="application/pdf" (change)="uploadProof(currentItem.resourceId, fileInput.files)" #fileInput [disabled]="!currentItem?.resourceId" />
                <button mat-mini-fab color="accent" class="mini-fab" (click)="fileInput.click()" [disabled]="!currentItem?.resourceId">
                  <mat-icon>add</mat-icon>
                </button>
                <label [class.cursor]="currentItem?.resourceId" [attr.for]="currentItem?.resourceId ? 'singleFile' : null">{{ 'ref_add_proof_pdf' | translate }}</label>
              </div>
            </div>
            <div class="col-4">
              <div class="justificatif" *ngIf="form.value.fileName">
                <button mat-mini-fab color="warn" class="mini-fab" (click)="deleteFile()" [disabled]="!(currentItem?.canUpdate || !currentItem?.resourceId)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
                <a class="resetPointerEvents" [href]="currentItem.resourceId ? justificationFilePath + form.value.fileDescription : form.value.fileDescription" target="_blank">{{ form.value.fileName }} </a>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
      <div class="trajet">
        <div class="title title-margin-top">
          <h3>{{ 'acheminement_routes_trips' | translate }}</h3>
          <button mat-mini-fab (click)="addTrip()">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <div *ngIf="currentItem && currentItem.trip && currentItem.trip.length > 0">
          <mat-card class="card-title">
            <div class="row">
              <div class="offset-1 col-2">{{ 'common_field_label' | translate }}</div>
              <div class="col-3">{{ 'acheminement_percentage' | translate }}</div>
            </div>
          </mat-card>

          <mat-accordion multi hideToggle>
            <!-- first as isFirst;" [expanded]="isFirst" -->

            <mat-expansion-panel *ngFor="let trip of currentItem?.trip; let tripIndex = index" expanded>
              <mat-expansion-panel-header #panel (click)="panel._toggle()">
                <mat-panel-title>
                  <div style="width: 100%">
                    <div class="row">
                      <div class="col-1">
                        <mat-icon class="icon-arrow" (click)="panel._toggle()"> {{ panel._isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
                      </div>
                      <div class="col-2">
                        {{ trip?.displayName }}
                      </div>
                      <div class="col-6">{{ trip?.ratio }}%</div>
                      <div class="col-2 text-right icon-color">
                        <mat-icon (click)="updateTrip(trip, tripIndex)">create</mat-icon>
                        <mat-icon (click)="deleteTrip(tripIndex)">delete_outline</mat-icon>
                      </div>
                    </div>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="panel-parcour">
                <div class="row text-bold">
                  <div class="col-2 offset-1">{{ 'acheminement_distance_km' | translate }}</div>
                  <div class="col-3">{{ 'common_field_transport' | translate }}</div>
                  <div class="col-2">{{ 'common_field_energy' | translate }}</div>
                  <div class="col-2">{{ 'common_double_freight' | translate }}</div>
                </div>

                <div class="row" *ngFor="let j of trip.journeys; let journeysIndex = index">
                  <div class="col-2 offset-1">
                    {{ numberFormatted(j.distance) }}
                  </div>
                  <div class="col-3">
                    {{ j.transportDisplayName }}
                  </div>
                  <div class="col-2">
                    {{ j.energyDisplayName ? j.energyDisplayName : j?.energyDescription ? j?.energyDescription : ('common_no_energy' | translate) }}
                  </div>
                  <div class="col-2">
                    {{ j.doubleCargo ? ('acheminement_yes' | translate) : j.doubleCargo == null ? ('acheminement_not_applicable' | translate) : ('acheminement_no' | translate) }}
                  </div>
                  <div class="col-2 text-right icon-color padding-right">
                    <mat-icon (click)="updateJourney(j, tripIndex)"> create</mat-icon>
                    <mat-icon (click)="deleteJourney(tripIndex, journeysIndex)">delete_outline </mat-icon>
                  </div>
                </div>
                <div class="add-trajet" (click)="addJourney(tripIndex)">
                  <button mat-mini-fab>
                    <mat-icon>add</mat-icon>
                  </button>
                  <span> {{ 'acheminement_create_trip' | translate }}</span>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          <div *ngIf="currentItem?.trip?.length" class="ratio">{{ 'acheminement_total_ratio' | translate }} : {{ tripsTotalRatio() }}%</div>
          <div *ngIf="hasTripsRatioError()" class="mat-error ratioError">{{ 'acheminement_error_trips_ratio_100' | translate }}</div>
        </div>
      </div>
    </div>
  </form>
</div>
